import { ShopItemType } from '@sorare/core/src/__generated__/globalTypes';

import { ShopItemPicker } from '@sorare/gameplay/src/components/shopItems/ShopItemPicker';

const ClubShopUtilityPage = () => {
  return (
    <ShopItemPicker
      types={[ShopItemType.APPEARANCE_BOOST, ShopItemType.COMMON_CARD_SWAP]}
    />
  );
};

export default ClubShopUtilityPage;
